/*
 * PWA install plumbing. Captures the `beforeinstallprompt` event as early as
 * possible — it can fire before React mounts, so we listen at module-eval time
 * (this module is imported at the top of index.js) and stash the event for the
 * InstallPrompt component to consume. Also clears on `appinstalled`.
 */

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Suppress Chrome's default mini-infobar; we present our own button.
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(deferredPrompt));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(null));
  });
}

export function getDeferredPrompt() {
  return deferredPrompt;
}

export function clearDeferredPrompt() {
  deferredPrompt = null;
}

export function subscribeInstall(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
